import { IContractValue } from "@components/global/new/ContractSelector/ContractSelector.props";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import { formatMinerMeta, IMinerMeta } from "@services/changeMinerSettings";
import { IAdminMinerTable } from "@services/getMinerInfo";
import {
  IMiningPlanOptions,
  IReproxyLink,
  MinerLocationRaw,
} from "@services/getMinerList";
import { UserI } from "@services/getUsers";
import {
  IMinerSettings,
  MinerAdminMiningEvent,
  MinerBaseEvent,
  MinerCustomerEvent,
  MinerDefaultSpeedEvent,
  MinerDropSpeedEvent,
  MinerHashEvent,
  MinerIdEvent,
  MinerPercentEvent,
  MinerSmoothEvent,
  MinerStartStopEvent,
  MinerStatusEvent,
  MinerTypeEvent,
  UserSettingEvent,
} from "@services/http/socket/responses";

export enum MinerActions {
  SpeedAndStatus = "SpeedAndStatus",
  Miner = "Miner",
  Status = "Status",
  Hashrate = "Hashrate",
  AdminStartStop = "AdminStartStop",
  StartStop = "StartStop",
  SettingsSpeed = "SettingsSpeed",
  AlgoSpeed = "AlgoSpeed",
  MinerId = "MinerId",
  MinerType = "MinerType",
  DefaultSpeed = "DefaultSpeed",
  DropSpeed = "DropSpeed",
  Settings = "Settings",
  Notes = "Notes",
  AppendMetaToAdminNotes = "AppendMetaToAdminNotes",
  Customer = "Customer",
  Plan = "Plan",
  Percent = "Percent",
  Smooth = "Smooth",
  Pool = "Pool",
  Location = "Location",
  Photos = "Photos",
  Sn = "Sn",
  Pn = "Pn",
  Meta = "Meta",
  Contract = "Contract",
  InstallationDate = "InstallationDate",
  ContractAndPlan = "ContractAndPlan",
  ProxyLink = "ProxyLink",
  AllSettingsAdd = "AllSettings_ADD",
  AllSettingsRemoveByUserId = "AllSettings_REMOVE_BY_USER_ID",
  ResetHasErrors = "ResetHasErrors",
  // Ip = "Ip",
  // Mac = "Mac",
  // Port = "Port",
  // Password = "Password",
  // UCP = "Ucp",
}
export const ReproxyLinkRemoveEventTag = "'remove-reproxy-link'";
export const ReproxyPortUpdateEventTag = "update-reproxy-port";
export const ReproxyPortListEventTag = "list-reproxy-ports";
export interface IReproxyLinkEvent {
  readonly minerId: number;
}

export interface ReproxyPortUpdateEvent {
  readonly minerId: number;
  readonly port: number;
  readonly prevPort: number;
}

export interface ReproxyPortListEvent {
  readonly ports: {
    minerId: number;
    port: number
  }[];
}
export interface ISaveNotes {
  type: "a" | "u";
  value: string;
}
export interface MinerActionData {
  readonly type: MinerActions;
  readonly tag?: string;
  readonly payload:
  | MinerBaseEvent<any>
  | UserI
  | IAdminMinerTable
  | ISaveNotes
  | MinerLocationRaw
  | IMiningPlanOptions
  | IMinerSettings
  | string
  | string[]
  | number
  | IMinerMeta
  | { state: MINER_STATUSES_E }
  | IContractValue
  | IContractAndPlan
  | UserSettingEvent
  | IReproxyLink;
}

export interface IContractAndPlan {
  contract?: IContractValue;
  plan?: IMiningPlanOptions;
}

export default function minerReducer(
  miner: IAdminMinerTable,
  action: MinerActionData
): IAdminMinerTable {
  switch (action.type) {

    case MinerActions.SpeedAndStatus: {
      const value = action.payload as MinerHashEvent;
      return {
        ...miner,
        status: value.state,
        speed_current: value.speed,
        rejected: value.rejected,
        accepted: value.accepted,
      };
    }

    case MinerActions.Miner:
      const value = action.payload as IAdminMinerTable;
      return {
        ...value,
      };

    case MinerActions.ResetHasErrors:
      return {
        ...miner,
        has_errors: false,
      };

    case MinerActions.Status:
      return {
        ...miner,
        status: (action.payload as MinerStatusEvent).state,
      };

    case MinerActions.Hashrate:
      const data = action.payload as MinerHashEvent;
      return {
        ...miner,
        speed_current: data.speed,
        rejected: data.rejected,
        accepted: data.accepted,
      };

    case MinerActions.AdminStartStop:
      return {
        ...miner,
        admin_mining_do: (action.payload as MinerAdminMiningEvent).admin_mining,
      };

    case MinerActions.StartStop:
      let startStopData = action.payload as MinerStartStopEvent;
      // switch (startStopData.action) {
      //   case "start":
      //     return {
      //       ...miner,
      //       status: MINER_STATUSES_E.STARTING,
      //     };
      //   case "stop":
      //     return {
      //       ...miner,
      //       status: MINER_STATUSES_E.STOPED,
      //     };
      // }
      return {
        ...miner,
        // status: startStopData.new_status,
      };
    //case MinerActions.SettingsSpeed:
    //return;
    //case MinerActions.AlgoSpeed:
    //return;
    case MinerActions.MinerId:
      return {
        ...miner,
        miner_id: (action.payload as MinerIdEvent).miner_id,
      };

    case MinerActions.MinerType:
      return {
        ...miner,
        profile: (action.payload as MinerTypeEvent).type,
      };

    case MinerActions.DefaultSpeed:
      return {
        ...miner,
        speed_default: (action.payload as MinerDefaultSpeedEvent).speed,
      };

    case MinerActions.DropSpeed:
      const pl = action.payload as MinerDropSpeedEvent;
      return {
        ...miner,
        notifications: pl.notifications,
        speed_drop: pl.speed,
      };

    case MinerActions.Location:
      const location = action.payload as MinerLocationRaw;
      return {
        ...miner,
        location_raw: {
          ...location,
          address: location.address
            ? location.address
            : miner.location_raw?.address || "",
        },
      };

    case MinerActions.Notes:
      const notes = action.payload as ISaveNotes;
      const user_notes = notes.type === "u" ? notes.value : miner.user_note;
      const admin_text = notes.type === "a" ? notes.value : miner.admin_note;
      return {
        ...miner,
        admin_note: admin_text,
        user_note: user_notes,
      };

    case MinerActions.AppendMetaToAdminNotes:
      if (!miner.meta) return miner;
      const newNotes = action.payload as string;
      return {
        ...miner,
        admin_note: newNotes,
      }

    case MinerActions.Customer:
      const {
        customer_email,
        customer_id,
        customer_uuid,
        customer_name
      } = action.payload as MinerCustomerEvent;
      return {
        ...miner,
        customer_email,
        customer_id,
        customer_uuid,
        customer_name,
      };

    case MinerActions.Percent:
      const percentData = action.payload as MinerPercentEvent;
      return {
        ...miner,
        admin_mining_setting: "" + percentData.setting_id,
        proof: percentData.percent,
        admin_mining_proof: percentData.admin_time,
      };

    case MinerActions.Settings:
      return {
        ...miner,
        setting: (action.payload as IMinerSettings).name,
        settingid: +(action.payload as IMinerSettings).setting_id,
        is_own_mining: (action.payload as IMinerSettings).is_own_mining,
      };

    case MinerActions.Smooth:
      return {
        ...miner,
        smooth: (action.payload as MinerSmoothEvent).smooth,
      };
    case MinerActions.Photos:
      return {
        ...miner,
        photos: action.payload as string[],
      };

    case MinerActions.Sn:
      return {
        ...miner,
        meta: { ...miner.meta, sn: action.payload as string },
      };
    case MinerActions.Pn:
      return {
        ...miner,
        meta: { ...miner.meta, pn: action.payload as string },
      };
    case MinerActions.Meta:
      return {
        ...miner,
        meta: action.payload as IMinerMeta,
      };

    case MinerActions.Plan: {
      const payload = action.payload as IMiningPlanOptions;
      return {
        ...miner,
        plan: payload
      }
    }

    case MinerActions.Contract: {
      const payload = action.payload as IContractValue;
      return {
        ...miner,
        contract_id: payload.id,
        contract_name: payload.name,
      };
    }

    case MinerActions.ContractAndPlan: {
      const payload = action.payload as IContractAndPlan;
      return {
        ...miner,
        plan: payload.plan ?? {
          id: -1,
          name: "",
          schedule: [],
          meta: "",
        },
        contract_id: payload.contract?.id,
        contract_name: payload.contract?.name,
      };
    }
    case MinerActions.InstallationDate: {
      const pl = action.payload as string;
      return {
        ...miner,
        installed: pl,
      };
    }
    case MinerActions.ProxyLink: {
      const payload = action.payload as IReproxyLink;
      if (payload.Port > 0) {
        return {
          ...miner,
          reproxy_link: payload
        }
      } else {
        return {
          ...miner,
          reproxy_link: undefined
        }
      }
    }
    case MinerActions.AllSettingsAdd: {
      const payload = action.payload as UserSettingEvent;
      if (miner.all_settings?.some(s => s.id === payload.id)) {
        return miner;
      }
      return {
        ...miner,
        all_settings: (miner.all_settings ?? []).concat({
          id: payload.id,
          user_id: payload.user_id,
          email: payload.email,
          name: payload.name,
          hash: payload.hash,
          Pools: payload.pools,
          used_count: payload.used_count,
          is_default: payload.is_default,
        }),
      };
    }

    case MinerActions.AllSettingsRemoveByUserId: {
      const userId = action.payload as number;
      return {
        ...miner,
        all_settings: miner.all_settings?.filter(s => s.user_id !== userId) ?? [],
      };
    }
    // case MinerActions.Ip:
    //   return {
    //     ...miner,
    //     meta: { ...miner.meta, ip: action.payload as string },
    //   };
    // case MinerActions.Mac:
    //   return {
    //     ...miner,
    //     meta: { ...miner.meta, mac: action.payload as string },
    //   };
    // case MinerActions.Port:
    //   return {
    //     ...miner,
    //     meta: { ...miner.meta, port: action.payload as string },
    //   };
    // case MinerActions.Password:
    //   return {
    //     ...miner,
    //     meta: { ...miner.meta, password: action.payload as string },
    //   };
    // case MinerActions.UCP:
    //   return {
    //     ...miner,
    //     meta: { ...miner.meta, ucp: action.payload as boolean },
    //   };
    default:
      return miner;
  }
}
